module.exports = __webpack_public_path__ + "static/media/categories-logo-webflow.6ca825a1.svg";